/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
/*
 * DUE FOR DECOMMISSION. Its one remaining caller is FixedAssetsPageComponent; every other user
 * has moved to AgentDataService.getOmcFor(), which answers through the OMC team's primaryAgentId
 * rather than asking which agencies may act here. When that page moves across too, delete this
 * file, the OmcAgent model, OmcAgentController and its route in api.php.
 */
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { OmcAgent } from '@src/app/model/OmcAgent';

@Injectable({
    providedIn: 'root'
})
export class OmcAgentService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);


    protected get baseUrl() {
        return this.getAjaxPath('omcAgents');
    }
    protected cache: OmcAgent[];
    protected typeString = 'OmcAgent';

    /* Transformation that now happens server side..
    protected enhanceList(items: OmcAgent[]) {
        const map: Map<uuid, OmcAgent> = new Map();
        const newItems: OmcAgent[] = [];
        items.forEach( oa => {
            if (!map.has(oa.agentTeamId)) {
                const newItem = { id: oa.agentTeamId, name: oa.agentTeam.name, roles: [] } as OmcAgent;
                map.set(oa.agentTeamId, newItem);
                newItems.push(newItem);
                oa.name = oa.agentTeam.name;
            }
            map.get(oa.agentTeamId).roles.push(oa);
        });
        return newItems;
    }
    */
}
